<div class="contact-card">

  <div class="contact-heading d-flex justify-content-start align-items-end">
    <img src="assets/images/Icon_speech_bubble_black_48.svg" [alt]="'mpupContact.getInTouch' | mbTranslate" />
    <h2>{{'mpupContact.getInTouch' | mbTranslate}}</h2>
  </div>

  <div>
    <h3>{{'mpupContact.heading' | mbTranslate}}</h3>
    <h3>{{'mpupContact.happyToHelp' | mbTranslate}}</h3>
  </div>

  <div class="contact-info d-flex flex-column justify-content-between align-items-start">
    <div class="d-flex justify-content-start align-items-center gap-0-5">
      <img src="assets/images/Icon_mail_purple.svg" alt="Mail icon"/>
      <a [href]="'mailto:' + getContact().email" class="contact-link">{{getContact().email}}</a>
    </div>

    <div class="d-flex justify-content-start align-items-center gap-0-5">
      <img src="assets/images/icon_phone_purple.svg" alt="Phone icon">
      <p class="contact-link">{{getContact().phone}}</p>
    </div>
  </div>

  <img class="cell-image" src="assets/images/mpup_background_cell.png" alt="cell image"/>

</div>
